/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response after starting transcription.
 * @export
 * @interface StartTranscriptionResponse
 */
export interface StartTranscriptionResponse {
    /**
     * Transcription job name
     * @type {string}
     * @memberof StartTranscriptionResponse
     */
    jobName: string;
    /**
     * S3 URI of the media file being transcribed
     * @type {string}
     * @memberof StartTranscriptionResponse
     */
    s3Uri: string;
}

/**
 * Check if a given object implements the StartTranscriptionResponse interface.
 */
export function instanceOfStartTranscriptionResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jobName" in value;
    isInstance = isInstance && "s3Uri" in value;

    return isInstance;
}

export function StartTranscriptionResponseFromJSON(json: any): StartTranscriptionResponse {
    return StartTranscriptionResponseFromJSONTyped(json, false);
}

export function StartTranscriptionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartTranscriptionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobName': json['job_name'],
        's3Uri': json['s3_uri'],
    };
}

export function StartTranscriptionResponseToJSON(value?: StartTranscriptionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'job_name': value.jobName,
        's3_uri': value.s3Uri,
    };
}

